/** Bounded session cache for parsed metadata. Failed loads are evicted. */
export class SessionResourceCache {
  private entries = new Map<string, { expiresAt: number; promise: Promise<unknown> }>();
  constructor(private readonly maxEntries = 150, private readonly ttlMs = 10 * 60_000) {}
  clear() { this.entries.clear(); }
  async get<T>(key: string, load: () => Promise<T>, refresh = false): Promise<T> {
    const cached = this.entries.get(key);
    if (!refresh && cached && cached.expiresAt > Date.now()) {
      this.entries.delete(key);
      this.entries.set(key, cached);
      return structuredClone(await cached.promise) as T;
    }
    const entry = { expiresAt: Infinity, promise: Promise.resolve().then(load) as Promise<unknown> };
    this.entries.delete(key);
    this.entries.set(key, entry);
    while (this.entries.size > this.maxEntries) this.entries.delete(this.entries.keys().next().value!);
    try {
      const result = await entry.promise;
      entry.expiresAt = Date.now() + this.ttlMs;
      return structuredClone(result) as T;
    } catch (error) {
      if (this.entries.get(key) === entry) this.entries.delete(key);
      throw error;
    }
  }
}
